import { vueData } from '@/domain/services/VueData';

const defaultState = () => ({
	consumer: vueData.consumer,
});

const state = defaultState();

export { state as default, defaultState };
